module.exports = __webpack_public_path__ + "img/sales_incentive_plan_banner.4b678c43.jpg";